import axios from "./axios";
import qs from "qs";

export default {
  fetchPurchaseContracts(params) {
    return axios.get("/node/fetchPurchaseContracts", { params });
  },
  fetchPurchaseContract(params) {
    return axios.get("/node/fetchPurchaseContract", { params });
  },
  fetchPurchaseContractPrintData(params) {
    return axios.get("/node/fetchPurchaseContractPrintData", { params });
  },
  getPurchaseContractWordDownloadUrl(params) {
    const query = Object.keys(params || {})
      .filter(key => params[key] != null && params[key] !== "")
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join("&");
    return `/node/downloadPurchaseContractWord${query ? `?${query}` : ""}`;
  },
  addOrUpdatePurchaseContract(data) {
    return axios.post("/node/addOrUpdatePurchaseContract", qs.stringify(data));
  },
  deletePurchaseContract(data) {
    return axios.post("/node/deletePurchaseContract", qs.stringify(data));
  },
  voidPurchaseContract(data) {
    return axios.post("/node/voidPurchaseContract", qs.stringify(data));
  },
  confirmPurchaseContract(data) {
    return axios.post("/node/confirmPurchaseContract", qs.stringify(data));
  },
  updatePurchaseContractFile(data) {
    return axios.post("/node/updatePurchaseContractFile", qs.stringify(data));
  },
  updatePurchaseContractStatus(data) {
    return axios.post("/node/updatePurchaseContractStatus", qs.stringify(data));
  },
  fetchPurchaseContractStatusCounts(params) {
    return axios.get("/node/fetchPurchaseContractStatusCounts", { params });
  },
  previewPurchaseContractFromInvoices(data) {
    return axios.post("/node/previewPurchaseContractFromInvoices", qs.stringify(data));
  },
  createPurchaseContractFromInvoices(data) {
    return axios.post("/node/createPurchaseContractFromInvoices", qs.stringify(data));
  },
};
